// extracted by mini-css-extract-plugin
module.exports = {"bio__container":"Biography_bio__container__sKPI_","bio__label":"Biography_bio__label__34Vs2","bio__content":"Biography_bio__content__m3B2i"};